import React from "react";
import { Link } from "react-router-dom";
import SideBarNav from "./SideBarNav";
import { getSingleOrder } from "../../modules/actions/orderActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
class OrderHistory extends React.Component {
  componentDidMount() {
    const orderId = this.props.match.params.id;
    console.log(this.props.match.params.id);
    this.props.getSingleOrder(orderId);
  }
  getPriceByUseType(object,useType){

    let price = 0;

    switch (useType) {
      case "USA" :
        price = parseFloat(object.domesticPrice).toFixed(2);
        break;

      case "GLOBAL":
        price = parseFloat(object.globalPrice).toFixed(2);
        break;
    }

    return price;
  }
  render() {
    const { orderDetail } = this.props;

    //shipping Info
    const firstname = orderDetail.shipping
        ? orderDetail.shipping.firstname
        : null;

    const lastname = orderDetail.shipping
        ? orderDetail.shipping.lastname
        : null;
    const address1 = orderDetail.shipping
        ? orderDetail.shipping.address1
        : null;
    const address2 = orderDetail.shipping
        ? orderDetail.shipping.address2
        : null;
    const city = orderDetail.shipping ? orderDetail.shipping.city : null;
    const state = orderDetail.shipping ? orderDetail.shipping.state : null;
    const zipcode = orderDetail.shipping ? orderDetail.shipping.zipcode : null;
    const country = orderDetail.shipping ? orderDetail.shipping.country : null;

    //Billing Info
    const firstnameBilling = orderDetail.billing
        ? orderDetail.billing.firstname
        : null;

    const lastnameBilling = orderDetail.billing
        ? orderDetail.billing.lastname
        : null;
    const address1Billing = orderDetail.billing
        ? orderDetail.billing.address1
        : null;
    const address2Billing = orderDetail.billing
        ? orderDetail.billing.address2
        : null;
    const cityBilling = orderDetail.billing ? orderDetail.billing.city : null;
    const stateBilling = orderDetail.billing ? orderDetail.billing.state : null;
    const zipcodeBilling = orderDetail.billing
        ? orderDetail.billing.zipcode
        : null;
    const countryBilling = orderDetail.billing
        ? orderDetail.billing.country
        : null;

    let cart = orderDetail.cart ? orderDetail.cart : null;
    let cartType = cart ? cart.cartType : null;

    let days;
    let start;
    let end;
    if (cartType) {
      if (cartType === "rent" || cartType === "sim") {
        start = moment(new Date(cart.startDate));
        end = moment(new Date(cart.endDate));
        days = end.diff(start, "days");
      }
    }
    let price = 0;
    if (cart) {
      if (orderDetail.cart.useType == "USA") {
        price = parseFloat(orderDetail.cart.productId.domesticPrice).toFixed(2);
      }

      if (orderDetail.cart.useType == "GLOBAL") {
        price = parseFloat(orderDetail.cart.productId.globalPrice).toFixed(2);
      }
    }

    const transaction = orderDetail.paypal
        ? orderDetail.paypal.transactions[0].amount
        : null;

    //console.log(orderDetail);

    return (
        <section className="BodyContainer">
          <div className="container">
            <div className="row">
              <SideBarNav />

              <div className="col-lg-8 order-history">
                <div className="mt-0">
                  <h4 className="features_title">ORDER DETAILS</h4>

                  <div className="container-fluid shipping-odrer">
                    <div className="row orderSummary">
                      <div className="col-md-12 text-camelCase ">
                        <strong> Order ID :</strong>{" "}
                        {orderDetail.orderId}
                      </div>
                    </div>
                    <div className="row orderSummary">
                      <div className="col-md-12 text-camelCase ">
                        <strong> Order Placed On :</strong>{" "}
                        {moment(new Date(orderDetail.orderDate)).format("LL")}
                      </div>
                    </div>
                    <div className="row orderSummary">
                      <div className="col-md-12 text-camelCase">
                        <strong>Order Status:</strong>{" "}
                        {orderDetail.rentalStatus
                            ? orderDetail.rentalStatus
                            : "Unfilled"}
                      </div>
                    </div>
                    {orderDetail.shippingtrackingcode ? (
                        <div className="row orderSummary">
                          <div className="col-md-12 text-camelCase">
                            <strong>Shipping Tracking Number:</strong>{" "}
                            {orderDetail.shippingtrackingcode}
                          </div>
                        </div>
                    ) : null}
                    {(cartType === "rent") ? (
                        <div>
                          <div className="row orderSummary">
                            <div className="col-md-12 text-camelCase">
                              <strong> Rental Start Date:</strong>{" "}
                              {moment(new Date(start)).format("LL")}
                            </div>
                          </div>
                          <div className="row orderSummary">
                            <div className="col-md-12 text-camelCase">
                              <strong> Rental End Date:</strong>{" "}
                              {moment(new Date(end)).format("LL")}
                            </div>
                          </div>
                        </div>
                    ) : (cartType === "sim") ?
                        (
                            <div>
                              <div className="row orderSummary">
                                <div className="col-md-12 text-camelCase">
                                  <strong> SIM Activation Date:</strong>{" "}
                                  {moment(new Date(start)).format("LL")}
                                </div>
                              </div>
                              <div className="row orderSummary">
                                <div className="col-md-12 text-camelCase">
                                  <strong> SIM Deactivation Date:</strong>{" "}
                                  {moment(new Date(end)).format("LL")}
                                </div>
                              </div>
                            </div>
                        ) : null
                    }
                    <div className="row">
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                            <tr>
                              <td>
                                <div className="address-title">
                                  {" "}
                                  <strong>Shipping Address:</strong>
                                </div>
                                <div class="address">
                                  <br />
                                  {firstname} {lastname}
                                  <br />
                                  {address1}
                                  <br />
                                  {address2}
                                  <br />
                                  {city}, {state}, {zipcode}
                                  <br />
                                  {country}
                                </div>
                              </td>
                              <td>
                                <div className="address-title">
                                  {" "}
                                  <strong>Billing Address:</strong>
                                </div>
                                <div class="address">
                                  <br />
                                  {firstnameBilling} {lastnameBilling}
                                  <br />
                                  {address1Billing}
                                  <br />
                                  {address2Billing}
                                  <br />
                                  {cityBilling}, {stateBilling},{" "}
                                  {zipcodeBilling}
                                  <br />
                                  {countryBilling}
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    {(cartType==="device") ? (
                        <table className="table product-detail">
                          <thead>
                          <tr>
                            <th>Product</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Subtotal</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td>
                              {orderDetail.product
                                  ? orderDetail.product.name + (orderDetail.product.color ? ' - ' + orderDetail.product.color : '')
                                  : null}
                            </td>
                            <td>${this.getPriceByUseType(orderDetail.cart.product,orderDetail.cart.useType)}</td>
                            <td>x1</td>
                            <td>${this.getPriceByUseType(orderDetail.cart.product,orderDetail.cart.useType)}</td>
                          </tr>
                          {typeof orderDetail.cart.associated_product !== 'undefined' &&
                          orderDetail.cart.associated_product !== null ? (
                              <tr>
                                <td>
                                  {orderDetail.cart.associated_product.name} - {(orderDetail.cart.useType === "GLOBAL" && typeof orderDetail.country !== "undefined" && orderDetail.country !== null) ? orderDetail.country.name + " " + orderDetail.cart.recurring_profile.name : orderDetail.cart.useType + " " + orderDetail.cart.recurring_profile.name}
                                </td>
                                <td>${orderDetail.cart.recurring_profile.price}</td>
                                <td>x1</td>
                                <td>${orderDetail.cart.recurring_profile.price}</td>
                              </tr>
                          ) : null}
                          <tr className="result-row border-top">
                            <td />
                            <td />
                            <td>Shipping Fee</td>
                            <td>
                              ${transaction ? parseFloat(transaction.details.shipping).toFixed(2) : null}
                            </td>
                          </tr>

                          <tr className="result-row">
                            <td />
                            <td />
                            <td>Tax</td>
                            <td>${transaction ? transaction.details.tax : 0}</td>
                          </tr>

                          {typeof orderDetail.after_discount_totals_flat !== 'undefined' &&
                          orderDetail.after_discount_totals_flat !== null ? (

                              <tr className="result-row">
                                <td />
                                <td />
                                <td>Discount</td>
                                {/*<td>${orderDetail.after_discount_totals_flat.discount}</td>*/}
                                <td>${parseFloat(orderDetail.after_discount_totals[1].discount_price).toFixed(2)}</td>
                              </tr>

                          ) : null}

                          {/*<tr className="result-row">
                        <td />
                        <td />
                        <td />
                        <td />
                        <td>Shipping & Hadling</td>
                        <td>$7.25</td>
                          </tr>*/}
                          <tr className="result-row">
                            <td />
                            <td />
                            <td>
                              <strong>Grand Total</strong>
                            </td>
                            <td>
                              <strong>
                                ${transaction ? transaction.total : null}
                              </strong>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                    ): null}

                    {(cartType==="device_recharge") ? (
                        <table className="table product-detail">
                          <thead>
                          <tr>
                            <th>Product</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Subtotal</th>
                          </tr>
                          </thead>
                          <tbody>
                          {typeof orderDetail.cart.associated_product !== 'undefined' &&
                          orderDetail.cart.associated_product !== null ? (
                              <tr>
                                <td>
                                  {orderDetail.cart.associated_product.name} - {(orderDetail.cart.useType === "GLOBAL" && typeof orderDetail.country !== "undefined" && orderDetail.country !== null) ? orderDetail.country.name + " " + orderDetail.cart.recurring_profile.name : orderDetail.cart.useType + " " + orderDetail.cart.recurring_profile.name}
                                </td>
                                <td>${orderDetail.cart.recurring_profile.price}</td>
                                <td>x1</td>
                                <td>${orderDetail.cart.recurring_profile.price}</td>
                              </tr>
                          ) : null}
                          <tr className="result-row border-top">
                            <td />
                            <td />
                            <td>Shipping Fee</td>
                            <td>
                              ${transaction ? parseFloat(transaction.details.shipping).toFixed(2) : null}
                            </td>
                          </tr>

                          <tr className="result-row">
                            <td />
                            <td />
                            <td>Tax</td>
                            <td>${transaction ? parseFloat(transaction.details.tax).toFixed(2) : 0}</td>
                          </tr>

                          {typeof orderDetail.after_discount_totals_flat !== 'undefined' &&
                          orderDetail.after_discount_totals_flat !== null ? (

                              <tr className="result-row">
                                <td />
                                <td />
                                <td>Discount</td>
                                {/*<td>${orderDetail.after_discount_totals_flat.discount}</td>*/}
                                <td>${parseFloat(orderDetail.after_discount_totals[1].discount_price).toFixed(2)}</td>
                              </tr>

                          ) : null}

                          {/*<tr className="result-row">
                        <td />
                        <td />
                        <td />
                        <td />
                        <td>Shipping & Hadling</td>
                        <td>$7.25</td>
                          </tr>*/}
                          <tr className="result-row">
                            <td />
                            <td />
                            <td>
                              <strong>Grand Total</strong>
                            </td>
                            <td>
                              <strong>
                                ${transaction ? parseFloat(transaction.total).toFixed(2) : null}
                              </strong>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                    ): null}

                    {(cartType==="rent") ? (
                        <table className="table product-detail">
                          <thead>
                          <tr>
                            <th>product</th>
                            <th />
                            <th>sku</th>
                            <th>price</th>
                            <th>NUMBER OF DAYS </th>
                            <th>subtotal</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td>
                              {orderDetail.cart
                                  ? orderDetail.cart.productId.description
                                  : null}
                            </td>
                            <td />
                            <td>
                              {orderDetail.cart
                                  ? orderDetail.cart.productId.name
                                  : null}
                            </td>
                            <td>$ {price}</td>
                            <td>{days}</td>
                            <td>
                              ${transaction ? parseFloat(transaction.details.subtotal).toFixed(2) : null}
                            </td>
                          </tr>

                          <tr className="result-row border-top">
                            <td />
                            <td />
                            <td />
                            <td />
                            <td>Shipping Fee</td>
                            <td>
                              ${transaction ? parseFloat(transaction.details.shipping).toFixed(2) : null}
                            </td>
                          </tr>
                          {/* <tr className="result-row border-top">
                        <td />
                        <td />
                        <td />
                        <td />
                        <td>Subtotal</td>
                        <td>
                          {" "}
                          ${transaction ? transaction.details.subtotal : null}
                        </td>
                      </tr>
                      {(cartType = "rent") ? (
                        <tr className="result-row">
                          <td />
                          <td />
                          <td />
                          <td />
                          <td>Rent For {days} days</td>
                          <td>${cart ? price * cart.quantity * days : null}</td>
                        </tr>
                      ) : null} */}

                          <tr className="result-row">
                            <td />
                            <td />
                            <td />
                            <td />
                            <td>Tax</td>
                            <td>${transaction ? parseFloat(transaction.details.tax).toFixed(2) : 0}</td>
                          </tr>

                          {/*<tr className="result-row">
                        <td />
                        <td />
                        <td />
                        <td />
                        <td>Shipping & Hadling</td>
                        <td>$7.25</td>
                          </tr>*/}
                          <tr className="result-row">
                            <td />
                            <td />
                            <td />
                            <td />
                            <td>
                              <strong>Grand Total</strong>
                            </td>
                            <td>
                              <strong>
                                ${transaction ? parseFloat(transaction.total).toFixed(2) : null}
                              </strong>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                    ) : (cartType === "sim") ? (
                        <table className="table product-detail">
                          <thead>
                          <tr>
                            <th>product</th>
                            <th />
                            <th>price</th>
                            <th>NUMBER OF DAYS </th>
                            <th>subtotal</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td>
                              T-Mobile SIM Card
                            </td>
                            <td />
                            <td>$ {price}</td>
                            <td>{orderDetail.cart.productId.recurringPeriod}</td>
                            <td>
                              ${transaction ? parseFloat(transaction.details.subtotal).toFixed(2) : null}
                            </td>
                          </tr>

                          <tr className="result-row border-top">
                            <td />
                            <td />
                            <td />
                            <td>Shipping Fee</td>
                            <td>
                              ${transaction ? parseFloat(transaction.details.shipping).toFixed(2) : null}
                            </td>
                          </tr>
                          {/* <tr className="result-row border-top">
                        <td />
                        <td />
                        <td />
                        <td />
                        <td>Subtotal</td>
                        <td>
                          {" "}
                          ${transaction ? transaction.details.subtotal : null}
                        </td>
                      </tr>
                      {(cartType = "rent") ? (
                        <tr className="result-row">
                          <td />
                          <td />
                          <td />
                          <td />
                          <td>Rent For {days} days</td>
                          <td>${cart ? price * cart.quantity * days : null}</td>
                        </tr>
                      ) : null} */}

                          <tr className="result-row">
                            <td />
                            <td />
                            <td />
                            <td>Tax</td>
                            <td>${transaction ? parseFloat(transaction.details.tax).toFixed(2) : 0}</td>
                          </tr>

                          {/*<tr className="result-row">
                        <td />
                        <td />
                        <td />
                        <td />
                        <td>Shipping & Hadling</td>
                        <td>$7.25</td>
                          </tr>*/}
                          <tr className="result-row">
                            <td />
                            <td />
                            <td />
                            <td>
                              <strong>Grand Total</strong>
                            </td>
                            <td>
                              <strong>
                                ${transaction ? parseFloat(transaction.total).toFixed(2) : null}
                              </strong>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                    ): null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }
}
OrderHistory.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    orderDetail: state.order.orderDetail
  };
}

export default connect(
    mapStateToProps,
    { getSingleOrder, addFlashMessage }
)(OrderHistory);



// WEBPACK FOOTER //
// ./src/pages/dashboard/OrderDetail.js